import { render, staticRenderFns } from "./ReadAloudInfo.vue?vue&type=template&id=f8d22490&scoped=true&"
import script from "./ReadAloudInfo.vue?vue&type=script&lang=js&"
export * from "./ReadAloudInfo.vue?vue&type=script&lang=js&"
import style0 from "./ReadAloudInfo.vue?vue&type=style&index=0&id=f8d22490&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8d22490",
  null
  
)

export default component.exports